import { CaretCircleRightIcon } from '@phosphor-icons/react'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'

import { handleEmailMarketingConsent } from '@/app/actions/footer.newsletter-subscribe.actions'
import { Input } from '@/components/primitives/Input/Input'
import { Loader } from '@/components/primitives/Loader/Loader'
import { Toaster } from '@/components/primitives/Toaster/Toaster'

import { SocialIcons } from './SocialIcons'

import type { FooterType } from '@/types/contentful/footerType'

export const Newsletter = ({ icons, newsletterLabel }: { icons: FooterType['fields']['socialIcons']; newsletterLabel?: string }) => {
  const [email, setEmail] = useState('')

  const mutation = useMutation({
    mutationFn: handleEmailMarketingConsent,
    onSuccess: () => {
      setEmail('')
    },
  })

  const handleSubmit = () => {
    if (!email) return
    mutation.mutate(email)
  }

  const isLoading = mutation.isPending
  const response =
    mutation.isSuccess || mutation.isError
      ? {
          isSuccess: mutation?.data?.success,
          message: mutation?.data?.success ? 'Successfully subscribed to newsletter' : mutation.data?.error?.toString() || 'Failed to subscribe to newsletter',
        }
      : null

  return (
    <>
      <div>
        <div className="flex flex-col gap-4">
          <h2 className="text-base font-semibold text-primary-900">Newsletter</h2>
          <p className="text-base text-grey-700">{newsletterLabel ?? 'Sign up to receive Supagas offer'}</p>
          <div className="relative md:w-full lg:w-[334px]">
            <Input
              label="You email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value)
                mutation.reset()
              }}
            />
            <button type="submit" aria-label="Subscribe to newsletter" onClick={handleSubmit}>
              {!isLoading ? (
                <CaretCircleRightIcon weight="fill" size={32} className="absolute right-2 top-[-8px] translate-y-1/2 fill-primary-500" />
              ) : (
                <div className="absolute right-3 top-[-2px] flex size-[26px] translate-y-1/2 items-center justify-center rounded-full bg-primary-500">
                  <Loader type={'light'} />
                </div>
              )}
            </button>
          </div>
        </div>
        <ul className="hidden items-center justify-start gap-x-6 md:flex">
          <SocialIcons icons={icons} />
        </ul>
      </div>
      {response && !isLoading && <Toaster title={response.message} variant={response.isSuccess ? 'success' : 'error'} />}
    </>
  )
}
